import { CancellationReason } from '@/model';

import { BaseHttpController } from './BaseHttpController';

export class OrderCancellationReasonController extends BaseHttpController {
  static readonly ENDPOINT = 'order-cancellation-reason';

  constructor() {
    super(OrderCancellationReasonController.ENDPOINT);
  }

  async findAll(): Promise<CancellationReason[]> {
    const response = await this.http.get<CancellationReason[]>('');
    return response.data.map((r) => new CancellationReason(r));
  }
}
